import React, {Component} from "react";
import {Col, Divider, Icon, Input, Row, Slider, Spin, Tabs, Tooltip} from 'antd';
import {connect} from 'react-redux';
import cookie from "react-cookies";
import {
    getBmaPanel,
    getC240CanvasComponent,
    getSpeedPanel,
    getStainChooser,
    getVerticalBrushPanel
} from "../c240_slot_component_utils";
import {globalConfigurations, scanSpeed, scanTypeVals, specimenType} from '../../../utils/const';
import {getDeviceSeries, getSupportedSpecimenType, notNull} from "../../../utils/utils";
import {changeSpecimenType, setScanProfile, setScanSpeed, setScanZLevels, setScanZStepSize, setSpecimenType} from "redux_actions/preview_status.action";
import CaseSearchInputComponent from "./c240_case_search_component";
import {GLOBAL_CONFIG} from "../../../utils/enums";
import {getGlobalConfig, setGlobalConfig} from "../../../utils/api";
import {error_manager} from "../../../helper/error_manager";
import {notifyError} from "../../gammaviewer/utils/display.notification";
import { fetchAllDisplaySettings, fetchAllStainSettings, getNameFromId, getRecentlyUsedSettings, getViewerSettingDropdown } from "../slot_component_utils";
import { updateDefaultStainSettings, updateDisplaySettingsList, updateSettings } from "redux_actions/gamma.state.action";
import _ from "lodash";
import '../../../asset/style/workflow/slide.css';
import { aclPermissions, hasPermissions } from "const/ACLPermissions";
import {getBarcodeCrop} from "../preview_utils";


const {TabPane} = Tabs;

let SPECIMEN = {
    'PAP': specimenType.PAP,
    'HE': specimenType.HNE_TISSUE,
    'IHC': specimenType.IHC,
    'BM': specimenType.BM,
    'BLOOD': specimenType.BLOOD,
}

class GeneralPreviewSettingsComp extends Component {
    constructor(props) {
        super(props);

        this.state = {
            folderName: "",
            currentRotation: 270,
        }
    }

    componentDidMount = () => {
        this.is_superuser = cookie.loadAll().superuser === "true";

        if (this.props.preview) {
            this.props.dispatch(setScanSpeed(this.props.id, this.props.preview.speed));
            this.props.dispatch(setSpecimenType(this.props.id, this.props.preview.specimenType))
            this.props.dispatch(setScanZLevels(this.props.id, this.props.preview.zStackLevels))
            this.props.dispatch(setScanZStepSize(this.props.id, this.props.preview.stepSize))
            
        }
        this.getBarcodeData()
        this.addAllDisplaySettings()
    }

    changeScanningProfile = (value) => {
        let scanningProfile = this.props.displaySettingsList[value];
        this.props.dispatch(updateSettings(scanningProfile.name));
        this.props.dispatch(setScanProfile(this.props.id, scanningProfile.id));
        this.changeDefaultForStain(scanningProfile.id)
    }

    changeDefaultForStain = (id) => {
        if ((((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response||{}).autoPreviewThreshold !== true){
            let stainSetting = this.props.defaultStainSettings;
            stainSetting[this.props.preview?.specimenType].default_setting = id
            this.props.dispatch(updateDefaultStainSettings(stainSetting)); 
        }
    }

    addAllStainSettings() {
        fetchAllStainSettings(SPECIMEN)
            .then(settings => {
                let stainSetting = settings.reduce((settings, setting) => Object.assign(settings, {
                    [setting.stain_name]: setting,
                }), {})
                this.props.dispatch(updateDefaultStainSettings(stainSetting));
                this.setState({
                    stainFetching: false,
                })
                let id = this.props.defaultStainSettings[this.props.preview.specimenType]["default_setting"]
                if (this.props.preview.scanningProfile !== ""){
                    id = this.props.preview.scanningProfile;
                }
                this.changeScanningProfile(id)
            })
            .catch(error => error_manager("Failed to fetch Stain settings", error))
    }

    addAllDisplaySettings = () =>
        fetchAllDisplaySettings()
            .then((settings) => {
                let dispSetting =
                        settings.reduce((settings, setting) => Object.assign(settings, {
                            [setting.id]: setting,
                        }), {})
                this.props.dispatch(updateDisplaySettingsList(dispSetting))
                if ((((this.props.deviceStatus[this.props.device_id] || {}).scanner_health || {}).scanner_response||{}).autoPreviewThreshold === true) {
                    this.props.dispatch(changeSpecimenType(this.props.device_id, this.props.id, specimenType.AUTO));
                }
                this.addAllStainSettings()
            })
            .catch((error) => error_manager("Failed to fetch display settings", error))

    componentDidUpdate = (prevProps) => {
        // TODO: shift it for less calculations @spandan
        let supportedSpecs = this.props.deviceStatus?.scanner_health?.scanner_response?.supportedSpecimenTypes;
        SPECIMEN = getSupportedSpecimenType(SPECIMEN, supportedSpecs, true);

        if (prevProps.previewSlotsOnly.specimenType !== this.props.previewSlotsOnly.specimenType && !_.isEmpty(this.props.defaultStainSettings)){
            let id = this.props.defaultStainSettings[this.props.previewSlotsOnly.specimenType]["default_setting"];
            let name = getNameFromId(this.props.displaySettingsList, id)
            this.props.dispatch(updateSettings(name));
            this.props.dispatch(setScanProfile(this.props.id, id))
        }
    }

    setWBCCount = (count) => {
        this.props.onWBCCountChange(count);
        // this.props.dispatch(updateCountSlotWise([this.props.id, count]));
    }

    changeScanType = (key) => {
        this.props.onScanTypeChange(key);
    }

    fetchWSIdetails = () => {
        return <Col>{
            (this.props.previewSlotsOnly.speed === scanSpeed.FAST) ?
                <div className="arial-font" style={{fontSize: "13px"}}>
                    <Row>
                    <span>Fast scanning.</span> 
                    </Row>
                    <Row>
                        <span>Suitable for evenly cut tissue sections without artifacts.</span> 
                    </Row>
                </div> :
            (this.props.previewSlotsOnly.speed === scanSpeed.MEDIUM) ?
                <div className="arial-font" style={{fontSize: "13px"}}>
                    <Row>
                    <span>1.5x slower but safer mode of scanning. <b> Suitable for</b></span> 
                    </Row>
                    <Row>
                        <span> ○  Evenly cut tissue sections with few folds</span> 
                    </Row>
                    <Row>
                        <span> ○  PAP slides</span> 
                    </Row>
                    <Row>
                        <span> ○  Cytology smears without very thick areas</span> 
                    </Row>
                    <Row>
                        <span> ○  Old slides with air/dpx bubbles</span> 
                    </Row>
                </div> :
                <div className="arial-font" style={{fontSize: "13px"}}>
                    <Row>
                    <span>3x slower but very safe mode of scanning. <b> Suitable for</b></span> 
                    </Row>
                    <Row>
                        <span> ○ Tissue slides with heavy folds / dirt under cover slip / unevenly cut tissue sections</span> 
                    </Row>
                    <Row>
                        <span> ○ Cytology smears with thick sections</span> 
                    </Row>
                    <Row>
                        <span> ○ All things crazy!</span> 
                    </Row>
                </div>
        }
        </Col>
    }

    setFolderName = (value) => {
        this.setState({folderName: value});
        this.props.onFolderNameChange(value);
    }

    getBarcodeData = () => {
        getGlobalConfig().then(response => {
            if (response.status === 200) {
                if (notNull(response.data[GLOBAL_CONFIG.BARCODE_ROTATION_SCAN.key])) {
                    this.setState({currentRotation: response.data[GLOBAL_CONFIG.BARCODE_ROTATION_SCAN.key]})
                } else {
                    this.setState({currentRotation: 270})
                    this.setBarcodeData(GLOBAL_CONFIG.BARCODE_ROTATION_SCAN.key, 270)
                }
            }
        }).catch(err => error_manager("Failed to fetch key", err))
    }

    setBarcodeData = (key, value) => {
        setGlobalConfig(key, value).then(res => {
            if (res.status !== 200) {
                notifyError('barcode', `Error in setting ${key}`)
            }
        }).catch(err => error_manager("Failed to set key", err))
    };

    rotate = () => {
        let rotation = this.state.currentRotation
        rotation = (rotation + 90) % 360
        this.setState({
            currentRotation: rotation
        });
        this.setBarcodeData(GLOBAL_CONFIG.BARCODE_ROTATION_SCAN.key, rotation)
    }

    render() {
        const slideKey = this.props.cassetteKey + "S" + this.props.id;
        let trayKey = this.props.cassetteKey;
        let rack = parseInt(trayKey.split("T")[0].split("R")[1]);
        let tray = parseInt(trayKey.split("T")[1]);
        const previewCameraBarcodeUrl = getBarcodeCrop(this.props.id, tray, rack);

        let deviceType = (((this.props.deviceStatus || {}).scanner_health || {}).scanner_response || {})['deviceType']
        let isHemoLens = deviceType && getDeviceSeries(deviceType) === "HEMOLENS";

        return(
            <div className={"full-parent"}>
                <Row className={"full-width"} style={{height: '65%'}}>
                    <Col span={24}>
                        <Row>
                            {getC240CanvasComponent(this.props.status, this.props.previewCanvasRef, this.props.thresholdCanvasRef,
                                this.props.brushEraserPrevCanvasRef, this.props.regions, this.props.onCanvasUpdate, this.props.allowPainting, this.props.startPainting, this.props.paintCanvas, 
                                this.props.stopPainting, this.props.dropDistanceCanvas, this.props.dropDistanceCanvasRef, this.props.focusPointsCanvas, 
                                this.props.focusPointsCanvasRef, this.props.preview, this.props.deviceId, this.props.brushType,
                                this.props.showBrushOrEraserSize, rack, tray, this.props.id, this.props.slideType)}
                        </Row>
                        {/* <Row>
                            <Col className="selected-area-component">
                                Selected Area : {this.props.regionArea} mm2
                            </Col>
                        </Row> */}
                    </Col>
                </Row>
                <Row className={"full-width"} style={{height: '35%', padding: '25px 0 0 0'}} >
                    <Col span={4}>
                            <Row className="arial-font" style={{marginRight:10,fontSize:13}}><b>Slide Name</b></Row>
                            <Spin spinning={this.props.reading_barcode} tip="Trying to Read Barcode...">
                                <Input value={this.props.previewSlotsOnly.slideName}
                                       style={{width: 260, marginTop: "10px"}} onChange={this.props.onScanNameChange}/>
                            </Spin>
                        <Divider></Divider>
                        <Row className="arial-font" style={{marginRight: 10, fontSize: 13}}><b>Folder Name</b></Row>
                        {
                            globalConfigurations["ADD_TO_FOLDER_AT_PREVIEW"] === "true" ?
                                <Row style={{width: 260}}>
                                    <CaseSearchInputComponent value={this.props.previewSlotsOnly.folderName}
                                                              folderName={this.state.folderName}
                                                              setFolderName={this.setFolderName}/>
                                </Row> : null
                        }
                        <Tooltip placement="rightBottom" title={"Rotate Barcode"}>
                            <div className="c240-barcode-filled" onClick={this.rotate}>
                                <img className="horizontal-barcode-image" alt="Barcode" src={previewCameraBarcodeUrl}
                                     style={{
                                         height: '140px',
                                         width: 'auto',
                                         cursor: 'pointer',
                                         transformOrigin: "50% 50%",
                                         transform: `rotate(${this.state.currentRotation}deg)`,
                                         marginLeft: "10px"
                                     }}
                                />
                                <div className="rotate"><Icon type="reload"/></div>
                            </div>
                        </Tooltip>
                    </Col>
                    <Col span={5} offset={1}>
                        <Row>
                            <span className="arial-font"
                                  style={{marginRight: 10, fontSize: 13}}><b>Edit Area Selection</b></span>
                            {getVerticalBrushPanel(this.props.brushType, this.props.brushSize, this.props.changeBrushType,
                                this.props.movedBrushSizeSlider, this.props.brushShape, this.props.changeBrushShape)}
                        </Row>
                    </Col>
                    <Col span={4} offset={1}>
                        <Row style={{height: "100%"}}>
                            {(((this.props.deviceStatus || {}).scanner_health || {}).scanner_response||{}).autoPreviewThreshold === true ? 
                                <Row className="arial-font full-width" style={{fontSize: 13}}>
                                    <Row style={{fontWeight: "bold"}}>Select Threshold Level</Row>
                                    <Row>
                                        <Col>
                                            <Slider onChange={this.props.onAutoThreshLevelChange}
                                                    value={this.props.autoThresholdLevel}
                                                    min={this.props.preview.response.threshLevelResult.start}
                                                    max={this.props.preview.response.threshLevelResult.end - 1}/>
                                        </Col>
                                    </Row>
                                    {getRecentlyUsedSettings(this.props.displaySettingsList, this.props.displaySettings, this.changeScanningProfile)}
                                </Row>
                                : getStainChooser(this.props.onSpecimenTypeChange, this.props.previewSlotsOnly, Object.keys(SPECIMEN))
                            }
                            {getViewerSettingDropdown(this.props.previewSlotsOnly?.specimenType, this.props.displaySettings, this.props.displaySettingsList, this.changeScanningProfile, true)}
                        </Row>
                    </Col>
                    
                    <Col span={8} offset={1}>
                        <Row style={{marginTop: "-10px"}}>
                            <Tabs activeKey={this.props.scan_type} onChange={this.changeScanType} size="small">
                                <TabPane tab="WSI" key={scanTypeVals.WSI}>
                                    {getSpeedPanel(this.props.onScanSpeedChange, this.props.previewSlotsOnly, this.props.previewSlotsOnly.speed)}
                                    {this.fetchWSIdetails()}
                                </TabPane>
                                
                                {hasPermissions([aclPermissions.take_z_scans]) ?
                                <TabPane tab="Z SCAN" key={scanTypeVals.Z_STACK}>
                                    <Row style={{fontSize:13}} className="arial-font"><b>Multiple focal planes are captured for each field of view.</b></Row>
                                    <Row style={{fontSize:13}} className="arial-font">Creates an interface similar to manual fine focus at every point in the stitched scan using mouse-scroll wheel</Row>  
                                    <Row key={0} style={{ padding: 10 }}>
                                        <Row style={{fontSize:13}}>
                                            <Col span={10} className="z-stack-scan-text">
                                                Z Stack Levels
                                            </Col>
                                            <Col span={10}>
                                                <Input className="z-stack-scan-input-field" value={this.props.previewSlotsOnly.zStackLevels}
                                                    placeholder={10} onChange={this.props.onZLevelsChange} />
                                            </Col>
                                        </Row>
                                        <Row style={{fontSize:13}}>
                                            <Col span={10} className="z-stack-scan-text">
                                                Step Size (um)
                                            </Col>
                                            <Col span={10}>
                                                <Input className="z-stack-scan-input-field" value={this.props.previewSlotsOnly.stepSize}
                                                    placeholder={0.1} onChange={this.props.onStepSizeChange} />
                                            </Col>
                                        </Row>
                                    </Row>
                                    <Row style={{fontSize:13}} className="arial-font"><b>Ideal for</b></Row> 
                                    <Row style={{fontSize:13}} className="arial-font">1. Slides with over lapping cells ex. FNACs</Row> 
                                    <Row style={{fontSize:13}} className="arial-font">2. Thick tissue sections / sections with lots of folds</Row>
                                </TabPane> : null}

                                {this.props.previewSlotsOnly.specimenType === specimenType.BM ?
                                    <TabPane tab="FIELDS" key={scanTypeVals.BLOOD}>
                                        {getBmaPanel(isHemoLens, this.props.wbcCount, this.setWBCCount) }
                                    </TabPane>
                                    : null}
                            </Tabs>
                        </Row>
                    </Col>
                </Row>
            </div>
        )
    }
}


const mapStateToProps = (state, ownProps) => {
    let {displaySettings, displaySettingsList, defaultStainSettings} = state.gammaStateReducer
    return {
        deviceStatus: state.deviceStatusReducer[ownProps.deviceId],
        previewSlotsOnly: state.previewStatusReducer[ownProps.id],
        displaySettings,
        displaySettingsList,
        defaultStainSettings
    }
}

export default connect(mapStateToProps)(GeneralPreviewSettingsComp);